import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { BottomNav } from "./BottomNav";

interface LayoutProps {
  credits?: number;
}

export function Layout({ credits }: LayoutProps) {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header credits={credits} />
      <main className="mx-auto max-w-5xl px-4 pb-20 pt-4 md:pb-8">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
